import dayjs from 'dayjs';
import { IRecipient, StoreCategory } from '@tiendanube/common';
import { PersonalDataState } from 'domains/PagoNubeOnboarding/Onboarding/types';

const getBirthDate = (
  birthDateParam: string | undefined,
): string | undefined => {
  if (!birthDateParam) return undefined;
  const date = dayjs(birthDateParam);
  return date.isValid() ? date.format('YYYY-MM-DD') : undefined;
};

const getLine = (address) => {
  let street = '';
  let streetNumber = 0;
  if (address?.line) {
    const addressLine = address.line.split(' ');
    street = addressLine[0];
    streetNumber = Number(addressLine[1]);
  }
  return { street, streetNumber };
};

const fromStoreCategory = (value?: StoreCategory): string | undefined => {
  if (!value) return undefined;
  return value as unknown as string;
};

export const mapRecipientToPersonalData = (
  recipient: IRecipient,
): PersonalDataState => {
  if (recipient.kyc) {
    const { address, individual, phoneNumber, phoneNumberPrefix } =
      recipient.kyc;
    const { street, streetNumber } = getLine(address);
    return {
      birthDate: getBirthDate(individual?.birthDate),
      city: address?.city || '',
      locality: address?.city || '',
      firstName: individual?.firstName || '',
      lastName: individual?.lastName || '',
      phoneNumber: phoneNumber || '',
      phoneNumberPrefix: phoneNumberPrefix || '+52',
      state: address?.state || '',
      storeCategory: fromStoreCategory(recipient.kyc.category),
      street: street || '',
      streetNumber: streetNumber || 0,
      zipCode: address?.postalCode || '',
    };
  } else {
    return {};
  }
};
